import IconComponent from "app/shared-components/IconComponent";
import React, { useState, useRef, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "../utilities/AgGridTable";
import ListPageHeader from "../utilities/ListPageHeader";
import { CountryIconComponent } from "app/shared-components/IconComponent";
import { useMediaQuery, useTheme } from '@mui/material';

const Ports = () => {
       const theme = useTheme();
      const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [selectedRows, setSelectedRows] = useState([]);
    const [rowData, setRowData] = useState([]);
    const perPage = 10;
    const [gridApi, setGridApi] = useState(null);
    const [error, setError] = useState();
    const navigate = useNavigate();
    const gridRef = useRef();
    const [deleteDisable, setDeleteDisable] = useState(true);
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [columnDefs, setColumnDefs] = useState([
        { field: 'portCode', enableRowGroup: true },
        { field: 'displayName', enableRowGroup: true, headerName: 'Port Name' },
        { field: 'countryName', enableRowGroup: true, headerName: 'Country', cellRenderer: CountryIconComponent },
    ]);
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ports}`;

    const onBtExport = useCallback(() => {
        const params = {
            fileName: 'Ports.xlsx',
            sheetName: 'Ports'
        }
        gridRef.current.api.exportDataAsExcel(params);
    }, []);

    const handlePurge = (e) => {
        selectedRows.map(async (row) => {
            try {
                await OAuthService.deleteData(url, row?._links?.port?.href.split('/').pop());
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                loadData();
            } catch (error) {
                setError(error.message);
            }
        });
    };

    const onGridReady = (params) => {
        setGridApi(params.api);
    };
    const loadData = async () => {
        gridApi?.showLoadingOverlay();
        try {
            const list = await OAuthService.getList(url + `?sort=portCode,asc&size=1000`);
            const ports = list.data?._embedded?.ports;
            setRowData(ports);
        } catch (error) {
            setError(error.message);
        } finally {
    gridApi?.hideOverlay();
  }
    }

    useEffect(() => {
        if (gridApi) {
            loadData();
        }
    }, [gridApi]);

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }

    
    const goToRoleEdit = useCallback(
        (data) => {
          const id = data?._links?.self?.href.split('/').pop();
          if (id) {
            navigate('/editPort/' + id);
          }
        },
        [navigate],
      );
    
      const onRowDoubleClicked = (params) => {
        if (isMobile) return; // handled by onRowClicked instead
        goToRoleEdit(params?.data);
      };
    
      const onRowClicked = (params) => {
        if (!isMobile) return; // desktop keeps double-click only
        goToRoleEdit(params?.data);
      };
    useEffect(() => {
        if (selectedRows.length > 0) {
            setDeleteDisable(false)
        } else {
            setDeleteDisable(true)
        }
    }, [selectedRows])

    return (
        <>
            <ListPageHeader
                componentName="Port"
                onBtExport={onBtExport}
                handlePurge={handlePurge}
                addPageLink="/addPort"
                pageName="Port List"
                deleteDisable={deleteDisable}
                error={error}
                successMsg={successMsg}
                snackState={snackState}
                gridRef={gridRef}
            />
            <div className="h-full">
                <AgGridTable
                    columnDefs={columnDefs}
                    onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                    onRowDoubleClicked={onRowDoubleClicked}
                    onRowClicked={onRowClicked}
                    gridRef={gridRef}
                    rowData={rowData}
                    paginationPageSize={perPage}
                    cacheBlockSize={perPage}
                    saveGridStateName={'portList'}
                />
            </div>
        </>
    );
}

export default Ports;
